import { DateTime } from 'luxon';

import { SafeBaseObject } from '@app/core/models/base-object.models';

export interface IReservationApiGetMultiBookingParams {
  SupplierID?: number;
  StartDate?: string;
  EndDate?: string;
  Currency?: string;
  PackageID?: number;
  ServiceID?: number;
  OptionID?: number;
  BkgID?: number;
  Guests?: string;
  PageNum?: number;
  PageSize?: number;
}

export interface IReservationApiGetInvoicePackagesParams {
  TravelStartDateFrom?: DateTime;
  TravelStartDateTo?: DateTime;
}

export class ResMultiBookingInvoicePackage extends SafeBaseObject {
  packageID = 0;
  packageName = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ResMultiBookingItem extends SafeBaseObject {
  selected = false;

  bkgID = 0;
  itemName = '';
  serviceID = 0;
  optionID = 0;
  packageID?: number;
  packageName = '';
  guests = '';
  purchaseOrderID?: number;
  quantity = 0;
  status = '';
  isFinal = false;
  onRequest = false;
  costCurrency = '';
  currencyCodInvoice = '';

  estimatedCost = 0;
  estimatedCostTax = 0;
  amountInvoiceImported = 0;
  taxAmountInvoiceImported = 0;
  amountInvoice = 0;
  taxAmountInvoice = 0;
  outstandingCost = 0;
  outstandingCostTax = 0;

  // FE-only working fields for the editable Cost/Tax columns, not populated from the API
  cost = 0;
  tax = 0;
  taxPostingGroup = '';
  userModified = false;

  constructor(data?: IReservationApiMultiBookingItem) {
    super();
    if (data) this.updateData(data);
  }

  override updateData(data: IReservationApiMultiBookingItem): void {
    this.addMangledProperty(data);
  }
}

export interface IReservationApiMultiBookingItem {
  BkgID?: number;
  ItemName?: string;
  ServiceID?: number;
  OptionID?: number;
  PackageID?: number | null;
  PackageName?: string;
  Guests?: string;
  PurchaseOrderID?: number | null;
  Quantity?: number;
  Status?: string;
  IsFinal?: string;
  OnRequest?: string;
  CostCurrency?: string;
  CurrencyCodInvoice?: string;
  EstimatedCost?: number;
  EstimatedCostTax?: number;
  AmountInvoiceImported?: number;
  TaxAmountInvoiceImported?: number;
  AmountInvoice?: number;
  TaxAmountInvoice?: number;
}

export interface IReservationApiCreatePurchaseOrderBkgItem {
  BkgID: number;
  PackageID?: number;
  SupplierID: number;
  CompanyID: number;
  ServiceID: number;
  OptionID: number;
  Quantity: number;
  CostUnit: number;
  Cost: number;
  CostTax: number;
  OutstandingCost?: number;
  OutstandingCostTax?: number;
  TaxPostingGroup?: string;
  CurrencyCod: string;
}

export interface IReservationApiCreatePurchaseOrderParams {
  AmountInvoice?: number;
  TaxInvoice?: number;
  PostInvoice: 'Y',
  CreateReceipt: 'Y',
  CreateMLInvoice: 'Y',
  BkgItemList: IReservationApiCreatePurchaseOrderBkgItem[];
  FileID?: number;
  FileGuid?: string;
  FileName?: string;
  InvoiceNumber?: string;
  InvoiceDate?: string;
  DateFrom?: string;
  DateTo?: string;
}

export interface IReservationApiCreatePurchaseOrderResult {
  purchaseOrderID?: number;
  invoiceID?: number;
}
